import { useInjection } from "@linkfluence/core/di";
import { useQuery } from "@tanstack/react-query";
import { DiscoveryRow } from "@radarly/models/discovery";
import {
  InsightPageRepo,
  InsightPageRepositoryUID,
} from "../repositories/InsightPageRepo";

export function useDiscoveryDetails(
  projectId: number,
  workspaceId: number,
  meta: DiscoveryRow["meta"],
  template?: string
) {
  const repository = useInjection<InsightPageRepo>(InsightPageRepositoryUID);
  const {
    data,
    isLoading: loading,
    isError,
  } = useQuery(
    [
      "/insight-page/getDiscoveryDetails",
      { projectId, workspaceId, meta, template },
    ],
    () => {
      return repository.getDiscoveryDetails(
        projectId,
        workspaceId,
        meta,
        template
      );
    }
  );
  return {
    loading,
    page: data,
    isError,
  };
}
